import createConverter from './lib/create_converter';
import Organization from 'models/organization';

export default createConverter(Organization);
